import React, { FC, Fragment } from "react";
import { Box } from "@material-ui/core";
import { px } from "Configs/theme";
import { Project } from "domain-entities";
import {
	getScheduleEntryTypeIcon,
	useTranslateScheduleEntryType,
} from "Components/ScheduleEntryType/ScheduleEntryTypeHelper";
import { useTranslation } from "Providers/TranslationProvider";
import { DragElementWrapper, DragSourceOptions } from "react-dnd";
import { CalendarEntry } from "./CalendarEntryHelper";
import styled from "@emotion/styled";
import { useScheduleEntryTypes } from "Components/ScheduleEntryType/hooks/useScheduleEntryTypes";
import { useIsInternalAdmin } from "Components/Members/hooks/useIsInternalAdmin";

interface Props {
	isDragging: boolean;
	calendarEntry: CalendarEntry;
	projects: Project[];
	drag: DragElementWrapper<DragSourceOptions>;
}

const Div = styled.div`
	overflow: hidden;
	white-space: nowrap;
	display: flex;
	align-items: center;
	height: 100%;
	flex: 1;
	margin-left: ${px.s};
`;

const CalendarEntryContentView: FC<Props> = (props) => {
	const { t } = useTranslation();
	const translateScheduleEntryType = useTranslateScheduleEntryType();
	const isInternalAdmin = useIsInternalAdmin();
	const scheduleEntryType = useScheduleEntryTypes((state) =>
		state.items.find((item) => item.id === props.calendarEntry.typeId)
	);

	function renderName() {
		if (props.isDragging) return null;
		if (props.calendarEntry.projectId) {
			const project = props.projects.find(
				(project) => project.id === props.calendarEntry.projectId
			);

			if (project) {
				return project.name;
			}
		} else if (props.calendarEntry.typeId) {
			if (scheduleEntryType) {
				return (
					<Fragment>
						<Box display="flex" mr={px.xs}>
							{getScheduleEntryTypeIcon(scheduleEntryType.icon, px.xl)}
						</Box>
						{translateScheduleEntryType(scheduleEntryType)}
					</Fragment>
				);
			}
		}

		return t("Common_Assigned");
	}

	return (
		<Div ref={isInternalAdmin ? props.drag : undefined}>{renderName()}</Div>
	);
};

export default CalendarEntryContentView;
